import script from "./FamilyCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamilyCard.vue?vue&type=script&setup=true&lang=ts"

import "./FamilyCard.vue?vue&type=style&index=0&id=7c748833&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c748833"]])

export default __exports__